var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.875 17C32.875 25.7675 25.7675 32.875 17 32.875C8.23248 32.875 1.125 25.7675 1.125 17C1.125 8.23248 8.23248 1.125 17 1.125C25.7675 1.125 32.875 8.23248 32.875 17Z",
    fill: "#F79009",
    stroke: "#FEEBDD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 15.5H18.5V8.5625C18.5 8.16468 18.342 7.78314 18.0607 7.50184C17.7794 7.22054 17.3978 7.0625 17 7.0625C16.6022 7.0625 16.2206 7.22054 15.9393 7.50184C15.658 7.78314 15.5 8.16468 15.5 8.5625V15.5H8.5625C8.16468 15.5 7.78314 15.658 7.50184 15.9393C7.22054 16.2206 7.0625 16.6022 7.0625 17C7.0625 17.3978 7.22054 17.7794 7.50184 18.0607C7.78314 18.342 8.16468 18.5 8.5625 18.5H15.5V25.4375C15.5 25.8353 15.658 26.2169 15.9393 26.4982C16.2206 26.7795 16.6022 26.9375 17 26.9375C17.3978 26.9375 17.7794 26.7795 18.0607 26.4982C18.342 26.2169 18.5 25.8353 18.5 25.4375V18.5H25.4375C25.8353 18.5 26.2169 18.342 26.4982 18.0607C26.7795 17.7794 26.9375 17.3978 26.9375 17C26.9375 16.6022 26.7795 16.2206 26.4982 15.9393C26.2169 15.658 25.8353 15.5 25.4375 15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.fc6989d7f59dd0bb0f02515627a63710.svg";
export { ForwardRef as ReactComponent };